import { Box, Divider, Typography } from "@mui/material";
import AgentHeaderImage from "./AgentHeaderImage";
import VoucherHeaderDetails from "./VoucherHeaderDetails";
import ReservationRoomDetails from "./ReservationRoomDetails";
import VoucherTableContainer from "./VoucherTableContainer";
import GuestInformation from "./GuestInformation";
import CustomChip from "src/components/shared/CustomChip";
import { voucherTypes } from "src/utils/common";

const VoucherSection = ({ type, provider, headerImage, voucherDetails, clientVoucherDetails }) => {
    const config = voucherTypes[type];
    if (!config || !provider) return null;

    const items = provider[config.itemsKey]?.map(config.itemMapper) || [];
    const paxCount = items.reduce((sum, item) => sum + (item.PaxCount || 0), 0);

    return (
        <Box
            className="voucher-section"
            mb={4}
            sx={{ pageBreakAfter: "always" }}
        >
            <AgentHeaderImage headerImage={headerImage} />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 2 }}>
                <Typography variant="h2" sx={{ mr: 2 }}>
                    {config.title}
                </Typography>
                {voucherDetails?.SerialNumber >= 2 && (
                    <CustomChip
                        label="Reprint"
                        color="warning"
                        size="small"
                    />
                )}
            </Box>
            <VoucherHeaderDetails entity={provider} />
            <ReservationRoomDetails paxCount={paxCount} />
            <VoucherTableContainer allItems={items} />
            <GuestInformation guests={clientVoucherDetails?.Guests || []} />
            <Divider sx={{ my: 3 }} />
        </Box>
    );
};

export default VoucherSection;